import { AutoChargeThreshold } from "./auto-charge-threshold.model";
import { ChargeThreshold } from "./charge-threshold.model";

export class SmartChargeThreshold{
    constructor(
        public chargeThreshold: ChargeThreshold[],
        public autoChargeThreshold: AutoChargeThreshold
    ){}
}